/**
 * Adds a third, informational "Klarna Payments" radio to SPD's Payment Options
 * widget on the product page, alongside its own "Pay in Full" / "Instalment"
 * options. Klarna is a real checkout-time payment method (enabled in
 * Settings -> Payments), not a deposit/instalment plan, so this option carries
 * no special cart properties - selecting it should behave exactly like "Pay in
 * Full" as far as the cart is concerned, it just tells the customer Klarna is
 * available at checkout.
 *
 * The Klarna radio deliberately uses its OWN name/group, separate from SPD's
 * "payment-option" group - SPD has its own listeners bound directly to its two
 * radios and reacts badly to a value it doesn't recognise sharing its group.
 * Note also that SPD's widget (<ul class="spp2__widget-options">) is NOT
 * nested inside the product <form> in the DOM - they're separate branches
 * that SPD wires together with JS, not containment - so its hidden
 * "properties[...]" inputs have to be found by a page-wide query, not via
 * closest('form') from the widget.
 *
 * SPD renders its widget asynchronously, and appears to replace its whole
 * option list subtree at least once after an initial render (an observer
 * scoped to the first <ul> it finds sees that node swapped out and has
 * nothing left to watch - the Klarna option would flash briefly, then vanish
 * for good). So this keeps a single, permanent, document-level observer
 * running and re-queries the DOM fresh on every relevant mutation, rather
 * than trusting a specific node reference to still be live.
 */
(function () {
  var KLARNA_ID = 'payment-option-klarna';
  var KLARNA_NAME = 'payment-option-klarna-choice';

  function buildKlarnaOption() {
    var li = document.createElement('li');
    li.className = 'spp2__widget-option';
    li.setAttribute('data-editable', 'option_inactive');
    li.innerHTML =
      '<input type="radio" id="' + KLARNA_ID + '" name="' + KLARNA_NAME + '" value="klarna">' +
      '<div class="spp2__payment-option-content">' +
      '<div class="spp2__payment-option-heading">' +
      '<div class="spp2__radio" data-editable="radio"><div class="spp2__radio-inner" data-editable="radio_inner"></div></div>' +
      '<label for="' + KLARNA_ID + '" class="spp2__payment-option-label" data-editable="main">Klarna Payments</label>' +
      '</div>' +
      '</div>' +
      '<div class="spp2__widget-info" data-editable="secondary">' +
      '<div class="spp2__widget-note">' +
      '<span data-editable="secondary">Pay in full today using Klarna. Available as a payment method at checkout, subject to Klarna’s eligibility criteria.</span>' +
      '</div>' +
      '</div>';
    return li;
  }

  function wireGroup(list) {
    var klarnaRadio = list.querySelector('#' + KLARNA_ID);
    if (!klarnaRadio || klarnaRadio.dataset.wired) return;
    klarnaRadio.dataset.wired = '1';

    var spdRadios = list.querySelectorAll('input[name="payment-option"]');
    var allItems = list.querySelectorAll('.spp2__widget-option');

    function syncActiveClasses() {
      allItems.forEach(function (item) {
        var input = item.querySelector('input[type="radio"]');
        if (input) item.setAttribute('data-editable', input.checked ? 'option_active' : 'option_inactive');
      });
    }

    klarnaRadio.addEventListener('change', function () {
      if (!klarnaRadio.checked) return;
      spdRadios.forEach(function (radio) {
        radio.checked = false;
      });
      // SPD's hidden properties inputs live in a separate <form> elsewhere in
      // the DOM (not an ancestor of the widget) - see the file-level comment.
      document.querySelectorAll('input[name^="properties"]').forEach(function (input) {
        input.remove();
      });
      syncActiveClasses();
    });

    spdRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) klarnaRadio.checked = false;
        syncActiveClasses();
      });
    });
  }

  function injectInto() {
    var list = document.querySelector('.spp2__widget-options');
    if (!list || list.querySelector('#' + KLARNA_ID)) return;
    list.appendChild(buildKlarnaOption());
    wireGroup(list);
  }

  function start() {
    injectInto();
    // Keep watching for as long as the page lives, re-checking on every
    // mutation - cheap (an early-exit query) and the only way to survive SPD
    // swapping its widget subtree out from under a more narrowly scoped watch.
    new MutationObserver(injectInto).observe(document.body, { childList: true, subtree: true });
  }

  // Don't assume DOMContentLoaded hasn't fired yet - depending on how this
  // asset is served, it can run after that event, in which case a listener
  // registered for it would never fire.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
